<template>
  <div class="message-container" data-testid="next-tier-message">
    <div
      class="message"
      :class="
        nlpTiers.includes(this.customer.tierInfo.nextTier)
          ? `${this.customer.tierInfo.nextTier}-nlp`
          : this.customer.tierInfo.nextTier
      "
      data-testid="message"
    >
      <div class="icon-container">
        <i class="icon-upgrade-arrow sm"></i>
      </div>
      <div class="message-labels">
        <p data-testid="upgrade-label">
          <span data-testid="stays-nights-label">
            {{ setStayLabel }} {{ setBothMessage }} {{ setNightLabel }}
          </span>
          {{ translate('boUpgradeTierMessageLevel', undefined) }}
          <span class="message-desktop" data-testid="message-desktop">
            {{ translate('boUpgradeTierMessage', undefined, nextTierClass) }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { getTranslatedTier } from '../../../infrastructure/Utils'
import useNextTierLabel, { nightLabels, stayLabels } from '../../helpers/useNextTierLabel'

const { mapState } = createNamespacedHelpers('multiRoomDisplay')

export default {
  name: 'NextTierMessage',
  data: () => ({
    nlpTiers: ['Club', 'Premium', 'Vip']
  }),
  computed: {
    ...mapState(['customer']),

    nextTierClass() {
      return getTranslatedTier(this.customer.tierInfo.nextTier, this.translate)
    },

    isFfQubitFixesEnabled2() {
      return global.ConfigDynamic.isEnabled({
        key: 'default.qubit.fixes.2.active'
      })
    },

    translatedTierMessage() {
      if (this.isFfQubitFixesEnabled2) {
        return this.translate('boUpgradeTierMessage', undefined, this.nextTierClass.toUpperCase())
      } else {
        return this.translate(
          'boUpgradeTierMessage',
          undefined,
          this.customer.tierInfo.nextTier.toUpperCase()
        )
      }
    },
    setBothMessage() {
      if (this.customer.nextTier.stays && this.customer.nextTier.nights) {
        return useNextTierLabel(
          '',
          0,
          [],
          this.customer.nextTier.stays && this.customer.nextTier.nights
        )
      } else return ''
    },

    setStayLabel() {
      if (this.customer.nextTier.stays) {
        return useNextTierLabel('Stay', this.customer.nextTier.stays, stayLabels)
      } else return ''
    },

    setNightLabel() {
      if (this.customer.nextTier.nights) {
        return useNextTierLabel('Night', this.customer.nextTier.nights, nightLabels)
      } else return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.message-container {
  max-width: 1440px;
  margin: 2.4rem auto 0;
  padding: 0 4.8rem;
  border-radius: 0.8rem;

  @media screen and (max-width: 992px) {
    margin: 0;
    padding: 0;
  }
}
.message {
  display: grid;
  grid-template-columns: 2rem 1fr;
  grid-gap: 1rem;
  padding: 1rem 2rem;
  border-radius: 5px;
  color: #fff;

  .icon-container,
  .message-labels {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .message-desktop {
    font-weight: normal;
  }

  @media screen and (max-width: 992px) {
    margin: 0;
    border-radius: unset;
    .message-desktop {
      display: none;
    }
  }

  span {
    font-weight: bold;
  }

  p {
    margin: 0;
    margin-inline-start: 0.5rem;
  }

  &.Gold {
    background-color: rgba(197, 171, 105);
  }
  &.Platinum {
    background-color: #615f5f;
  }
  &.Silver {
    background-color: #b1b3b3;
  }
  &.Premium-nlp {
    background-color: #53565a;
    color: #fff;
  }
  &.Vip-nlp {
    background-color: #000;
    color: #fff;
  }
}
</style>
